import { useGigsterProfilesGigStatsSkillsList } from "@sidegigllc/api/client";
import { useQuery } from "@tanstack/react-query";
import { useAdminPro } from "api/queries/admin";
import {
  PROfileReviews,
  type PROfileReviewsProps,
  PROfileReviewsSkeleton,
} from "domains/pros/components/PROfileReviews";
import React from "react";
import type { SelectOption } from "types/utils";
import { reviewStatsQuery } from "./queries";

type PROfileReviewsContainerProps = { id: number };

export const PROfileReviewsContainer: React.FC<PROfileReviewsContainerProps> = ({ id }) => {
  const { data: pro } = useAdminPro({ id });
  const gigsterProfileId = pro?.gigster_profile?.id;

  const [selectedPosition, setSelectedPosition] = React.useState<SelectOption>();
  const { data: gigSummary } = useGigsterProfilesGigStatsSkillsList(gigsterProfileId ?? 0, {
    query: { enabled: gigsterProfileId != null },
  });
  const positions: Array<SelectOption> = (gigSummary ?? []).map((skill) => ({
    value: skill.skill_id,
    label: skill.skill_name,
  }));

  const { data: reviewStats } = useQuery(reviewStatsQuery({ id }, selectedPosition?.value));

  const transformedData: PROfileReviewsProps["data"] | undefined = reviewStats
    ? {
        overall: reviewStats.avg_rating,
        count: reviewStats.count,
        byRating: {
          5: reviewStats.overall_percentage_5_stars,
          4: reviewStats.overall_percentage_4_stars,
          3: reviewStats.overall_percentage_3_stars,
          2: reviewStats.overall_percentage_2_stars,
          1: reviewStats.overall_percentage_1_stars,
        },
        byCategory: {
          Punctuality: reviewStats.punctuality_avg_rating,
          Skillset: reviewStats.skillset_avg_rating,
          Preparedness: reviewStats.preparedness_avg_rating,
        },
      }
    : undefined;

  return transformedData ? (
    <PROfileReviews
      positions={positions}
      selectedPosition={selectedPosition}
      setSelectedPosition={setSelectedPosition}
      data={transformedData}
    />
  ) : (
    <PROfileReviewsSkeleton />
  );
};
